import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel } from '@mui/icons-material';

// material-ui
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { toast } from 'react-toastify';
import { useCallback } from 'react';
import useFetchData from 'hooks/useFetchData';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const columns = [
    { id: 'id', label: 'Count', minWidth: 30 },
    { id: 'clientName', label: 'Client Name', minWidth: 30 },
    { id: 'customerLoginUserName', label: 'Login User Name', minWidth: 30 },
    { id: 'amount', label: 'Amount', minWidth: 120 },
    { id: 'walletTypeName', label: 'Wallet Type Name', minWidth: 170 },
    { id: 'remark', label: 'Remark', minWidth: 120 },
    { id: 'createdBy', label: 'Created By', minWidth: 170 },
    { id: 'createdDate', label: 'Created Date', minWidth: 170, type: 'date' },
    { id: 'updatedBy', label: 'Updated By', minWidth: 170 },
    { id: 'updatedDate', label: 'Updated Date', minWidth: 170, type: 'date' }
];

const Adjustment = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();

    const [sales, setSales] = useState([]);
    const [filterSalesFrom, setFilerSalesFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterSalesTo, setFilerSalesTo] = useState(dayjs());
    const [filterAdjustmentClientName, setFilterAdjustmentClientName] = useState(0);
    const [filterAdjustmentWalletTypeId, setFilterAdjustmentWalletTypeId] = useState(0);
    const [filterAdjustmentSearchUserId, setFilterAdjustmentSearchUserId] = useState(0);
    const [filterAdjustmentSearchLoginUserName, setFilterAdjustmentSearchLoginUserName] = useState('');

    const [isLoading, setLoading] = useState(true);
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const { data: customerLoginUserNameOptions } = useFetchData('/Customer/LoginUserNames');

    const [isAllowedTransaction, setIsAllowedTransaction] = useState();
    //fetch customer names for autocomplete start
    const fetchIsAllowedTransaction = async () => {
        try {
            const res = await axiosInstance.get('/IsAllowed/Transaction', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setIsAllowedTransaction(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    //fetch customer names for autocomplete start
    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const fetchCustomerNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Customer/Names', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerNameOptions(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    const [usersList, setUsersList] = useState([]);
    //fetch customer names for autocomplete start
    const fetchUserNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Usernames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setUsersList(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    const [customerNameListArr, setCustomerNameListArr] = useState([]);
    //fetch customer names for autocomplete start
    const fetchCustomerNamesList = async () => {
        try {
            const res = await axiosInstance.get('/Customer/NameList', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerNameListArr(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    const [customerWalletTypes, setCustomerWalletTypes] = useState([]);
    const fetchCustomerWalletTypes = async () => {
        const customerGroups = await axiosInstance.get('/WalletTypes', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setCustomerWalletTypes(customerGroups.data);
    };

    //fetch sales start
    const [fetchAdjustmentLoading, setFetchAdjustmentLoading] = useState(false);
    const fetchAdjustment = async () => {
        if (!filterSalesFrom.isValid() || !filterSalesTo.isValid()) {
            warningAlert('Please fill all required fields.');
            return;
        }
        let adjustmentUrl = `/Adjustment/All?createdDateFrom=${filterSalesFrom.format('YYYY-MM-DD')}&createdDateTo=${filterSalesTo.format(
            'YYYY-MM-DD'
        )}`;
        // if (filterAdjustmentClientName !== 0) {
        //     adjustmentUrl += `&customerID=${filterAdjustmentClientName}`;
        // }
        if (filterAdjustmentSearchLoginUserName !== 0) {
            adjustmentUrl += `&loginUserName=${filterAdjustmentSearchLoginUserName}`;
        }
        if (filterAdjustmentWalletTypeId !== 0) {
            adjustmentUrl += `&walletTypeID=${filterAdjustmentWalletTypeId}`;
        }
        if (filterAdjustmentSearchUserId !== 0) {
            adjustmentUrl += `&searchUserID=${filterAdjustmentSearchUserId}`;
        }

        setFetchAdjustmentLoading(true);
        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(adjustmentUrl, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setSales(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFilterBtnDisabled(false);
            setFetchAdjustmentLoading(false);
        }
    };

    //fetch sales end

    //Insert Adjustment start
    const InsertSalesRecord = () => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [insertAdjustmentCustomerID, setInsertAdjustmentCustomerID] = useState('');
        const [customerValueWalletTypes, setCustomerValueWalletTypes] = useState(0);
        const [customerWalletRemark, setCustomerWalletRemark] = useState('');
        const [customerValueAmount, setCustomerValueAmount] = useState('');
        const [insertAdjustmentLoginUserName, setInsertAdjustmentLoginUserName] = useState('');

        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);
        const [insertAdjustmentLoading, setInsertAdjustmentLoading] = useState(false);

        const submitInsertAdjustment = async (e) => {
            setInsertBtnDisabled(true);
            setTimeout(() => {
                setInsertBtnDisabled(false);
            }, 3000);

            console.log('insertAdjustmentCustomerName', insertAdjustmentCustomerID);

            if (
                parseFloat(insertAdjustmentLoginUserName) === '' ||
                parseFloat(customerValueWalletTypes) === 0 ||
                parseFloat(customerValueAmount) === ''
            ) {
                warningAlert('Please fill all required fields.');
                return;
            }

            setInsertAdjustmentLoading(true);
            try {
                const res = await axiosInstance.post(
                    '/AdjustCustomerWalletBalance',
                    {
                        customerID: insertAdjustmentCustomerID,
                        walletTypeID: customerValueWalletTypes,
                        amount: customerValueAmount,
                        remark: customerWalletRemark,
                        loginUserName: insertAdjustmentLoginUserName
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Sales created successfully.');
                    fetchAdjustment();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertAdjustmentLoading(false);
            }
        };
        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                >
                    Insert Adjustment
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {insertAdjustmentLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Adjust Customer Wallet Balance
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '450px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} sx={{ mt: 3 }} md={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Customer Login UserName :
                                            </Typography>

                                            <Autocomplete
                                                freeSolo
                                                value={insertAdjustmentLoginUserName}
                                                onChange={(event, newValue) => {
                                                    setInsertAdjustmentLoginUserName(newValue);
                                                }}
                                                inputValue={insertAdjustmentLoginUserName}
                                                onInputChange={(event, newInputValue) => {
                                                    setInsertAdjustmentLoginUserName(newInputValue);
                                                }}
                                                id="controllable-states-demo"
                                                options={customerLoginUserNameOptions}
                                                sx={{ width: 170 }}
                                                renderInput={(params) => <TextField {...params} />}
                                                disableClearable
                                            />
                                            {/* <Select
                                                displayEmpty
                                                value={insertAdjustmentCustomerID}
                                                onChange={(e) => setInsertAdjustmentCustomerID(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Customer
                                                </MenuItem>
                                                {customerNameListArr.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select> */}
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Wallet Type :
                                            </Typography>
                                            <FormControl fullWidth>
                                                <Select
                                                    value={customerValueWalletTypes}
                                                    onChange={(e) => setCustomerValueWalletTypes(e.target.value)}
                                                >
                                                    <MenuItem sx={{ width: '100%' }} value={0}>
                                                        Select Wallet Type
                                                    </MenuItem>
                                                    {customerWalletTypes?.map((item, index) => (
                                                        <MenuItem key={index} value={item.id}>
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Amount :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={customerValueAmount}
                                                onChange={(e) => setCustomerValueAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Remark :
                                            </Typography>
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={customerWalletRemark}
                                                onChange={(e) => setCustomerWalletRemark(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertAdjustment()}
                                disabled={insertBtnDisabled}
                            >
                                Insert Adjustment
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //Insert Adjustment end

    //Change Adjustment start
    const UpdateAdjustment = ({ adjustment }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updateSalesRecordLoading, setUpateSalesRecordLoading] = useState(false);

        const [customerValueWalletTypes, setCustomerValueWalletTypes] = useState(adjustment.walletTypeID);
        const [customerWalletRemark, setCustomerWalletRemark] = useState(adjustment.remark);
        const [customerValueAmount, setCustomerValueAmount] = useState(adjustment.amount);

        const submitUpdateSales = async () => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);
            if (
                parseFloat(adjustment.customerID) === 0 ||
                parseFloat(customerValueWalletTypes) === 0 ||
                parseFloat(customerValueAmount) === ''
            ) {
                warningAlert('Please fill all required fields.');
                return;
            }
            setUpateSalesRecordLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/Adjustment',
                    {
                        id: adjustment.id,
                        customerID: adjustment.customerID,
                        walletTypeID: customerValueWalletTypes,
                        amount: customerValueAmount,
                        remark: customerWalletRemark
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Sales updated successfully.');
                    fetchAdjustment();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpateSalesRecordLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updateSalesRecordLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Change Adjustment
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '450px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Wallet Type :
                                            </Typography>
                                            <FormControl fullWidth>
                                                <Select
                                                    value={customerValueWalletTypes}
                                                    onChange={(e) => setCustomerValueWalletTypes(e.target.value)}
                                                >
                                                    <MenuItem sx={{ width: '100%' }} value={0}>
                                                        Select Wallet Type
                                                    </MenuItem>
                                                    {customerWalletTypes?.map((item, index) => (
                                                        <MenuItem key={index} value={item.id}>
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Amount :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={customerValueAmount}
                                                onChange={(e) => setCustomerValueAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Remark :
                                            </Typography>
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={customerWalletRemark}
                                                onChange={(e) => setCustomerWalletRemark(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdateSales()}
                                disabled={updateBtnDisabled}
                            >
                                Update
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //Change Adjustment end

    // With Promise All
    useEffect(() => {
        setLoading(true); // Set loading to true before starting the fetches

        // Define an array of async functions to fetch data
        const fetchFunctions = [
            fetchAdjustment(),
            fetchCustomerNamesList(),
            fetchCustomerWalletTypes(),
            fetchIsAllowedTransaction(),
            fetchUserNamesOptions(),
            fetchCustomerNamesOptions()
        ];

        // Use Promise.all to wait for all fetches to complete
        Promise.all(fetchFunctions)
            .then(() => {
                setLoading(false); // Set loading to false after all fetches are done
            })
            .catch((error) => {
                // Handle any errors that occurred during fetching
                console.error('Error fetching data:', error);
                setLoading(false); // Set loading to false even if there was an error
            });
    }, []);

    //sales table start
    function StickyHeadTable() {
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(100);

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
        };

        return (
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                        {column.label}
                                    </TableCell>
                                ))}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            let value = row[column.id];
                                            if (column.type && column.type === 'date') {
                                                if (value) {
                                                    const timeString12hr = new Date(
                                                        '1970-01-01T' + value.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    });
                                                    value = `${value.split('T')[0]} ${timeString12hr}`;
                                                }
                                            }
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </TableCell>
                                            );
                                        })}
                                        <TableCell>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}
                                            >
                                                <UpdateAdjustment adjustment={row} />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={sales.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
    //sales table end

    return (
        <Grid container item xs={12}>
            <InsertSalesRecord />

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerSalesFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerSalesTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Customer :
                        </Typography>
                        <Autocomplete
                            freeSolo
                            value={filterAdjustmentSearchLoginUserName}
                            onChange={(event, newValue) => {
                                setFilterAdjustmentSearchLoginUserName(newValue);
                            }}
                            inputValue={filterAdjustmentSearchLoginUserName}
                            onInputChange={(event, newInputValue) => {
                                setFilterAdjustmentSearchLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={customerLoginUserNameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                        {/* <Select
                            displayEmpty
                            value={filterAdjustmentClientName}
                            onChange={(e) => setFilterAdjustmentClientName(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value={0}>
                                Select Customer
                            </MenuItem>
                            {customerNameListArr.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select> */}
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Wallet Type
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterAdjustmentWalletTypeId}
                            onChange={(e) => setFilterAdjustmentWalletTypeId(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value={0}>
                                Select Package
                            </MenuItem>
                            {customerWalletTypes.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Search User
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterAdjustmentSearchUserId}
                            onChange={(e) => setFilterAdjustmentSearchUserId(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value={0}>
                                Select User
                            </MenuItem>
                            {usersList.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.userID} key={index}>
                                    {item.userName}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}
                    onClick={() => fetchAdjustment()}
                    disabled={filterBtnDisabled}
                >
                    Filter
                </Button>
            </Grid>

            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchAdjustmentLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <StickyHeadTable />
                )}
            </Box>
        </Grid>
    );
};

export default Adjustment;
